import { fetchGoogleSheetsData } from 'google-sheets-mapper';
import { REACT_APP_GOOGLE_API_KEY, REACT_APP_GOOGLE_SHEETS_ID } from './consts';

const fetchSheetOptions = async () => {
  try {
    const data = await fetchGoogleSheetsData({
      apiKey: REACT_APP_GOOGLE_API_KEY,
      sheetId: REACT_APP_GOOGLE_SHEETS_ID,
    });
    const sheetOptions = data.filter(element => element.id !== 'DA')
      .map((element, index) => ({
        id: element.id,
        headerRowIndex: index === 2 ? 6 : 5,
      }))
    return sheetOptions
  } catch (error) {
    throw error
  }
};

export const fetchSheetData = async () => {
  try{
    const sheetOptions = await fetchSheetOptions()
    const data = await fetchGoogleSheetsData({
      apiKey: REACT_APP_GOOGLE_API_KEY,
      sheetId: REACT_APP_GOOGLE_SHEETS_ID,
      sheetsOptions:sheetOptions,
    });
    return data
  } catch (error) {
    throw error
  }
};